import store from '../store';
import Common from './Common';
import { heFetch } from '../api/HeFetch';

export default class Payment {
    static getBraintreeToken() {
        const response = heFetch.post('/payment-methods/braintree/token', {
            headers: {
                Authorization: `Bearer ${store.getState().auth.accessToken}`
            }
        });

        return response;
    }

    static createStripeSetupIntent(paymentMethodId = null) {
        const response = heFetch.post('/payment-methods/stripe/setup-intent', {
            headers: {
                Authorization: `Bearer ${store.getState().auth.accessToken}`
            },
            ...(paymentMethodId && {
                data: { payment_method_id: paymentMethodId }
            })
        });
        return response;
    }

    static createStripePaymentIntent(data) {
        const params = {
            url: `/v1/payment/stripe/payment-intent`,
            method: 'post',
            data
        };
        return Common.request(params);
    }

    static setupPaymentMethodFutureUsage(paymentMethodId) {
        const response = heFetch.patch(`/payment-methods/${paymentMethodId}/setup-future-usage`, {
            headers: {
                Authorization: `Bearer ${store.getState().auth.accessToken}`
            }
        });

        return response;
    }
}
